import { gql } from '@apollo/client'

export const DELETE_STATE = gql`
  mutation deleteState($input: ID!) {
    data: deleteState(id: $input) {
      id
    }
  }
`
